export const parseHtmlTags = (htmlString: string) => {
  return htmlString.replace(/<[^>]+>/g, '')
}

export const convertHtmlSpace = (htmlString: string) => {
  return htmlString.replace(/&nbsp;/g, ' ')
}

export const convertHTMLParagraphBreaks = (htmlString: string) => {
  return htmlString.replace(/<p>/g, '').replace(/<\/p>/g, '\n\n')
}

const HTML_ENTITIES: Readonly<Record<string, string>> = {
  '&amp;': '&',
  '&apos;': "'",
  '&#39;': "'",
  '&gt;': '>',
  '&lt;': '<',
  '&nbsp;': ' ',
  '&quot;': '"',
}

export const getPlainTextFromCraftHtml = (value: unknown): string => {
  if (typeof value !== 'string') {
    return ''
  }

  const html = value.trim()
  if (!html) {
    return ''
  }

  return html
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&(amp|apos|#39|gt|lt|nbsp|quot);/g, (entity) => HTML_ENTITIES[entity] ?? entity)
    .replace(/\s+/g, ' ')
    .trim()
}

export const appendHttpsToUrl = (url: string) => {
  return `https:${url}`
}

export const formatIntoTwoDigits = (seconds: number): string => {
  switch (true) {
    case seconds <= 0:
      return '00'
    case seconds < 10:
      return seconds.toString().padStart(2, '0')
    default:
      return `${seconds}`
  }
}

export const formatSecsToTimeDisplay = (totalSeconds: number) => {
  if (totalSeconds < 0) {
    return ''
  }
  const minutes = Math.floor(totalSeconds / 60)
  const remainingSeconds = Math.floor(totalSeconds - minutes * 60)
  const secondsStr = formatIntoTwoDigits(remainingSeconds)
  const minutesStr = formatIntoTwoDigits(minutes)
  return `${minutesStr}:${secondsStr}`
}

export const getMediaTimeDisplay = (currentTime: number, duration: number): string => {
  return `${formatSecsToTimeDisplay(currentTime)} / ${formatSecsToTimeDisplay(duration)}`
}
